export default {
	downloadByBlob: ({ res, fileName = '下载文件.xlsx' }) => {
		const blob = new Blob([res])
		const link = document.createElement('a')
		link.download = fileName;
		link.href = URL.createObjectURL(blob)
		link.click()
		window.URL.revokeObjectURL(link.href); //释放掉blob对象
	}

} 
	
